import { type Filter, type FilterGroup } from '@hungryroot/components-filters';
import { tags } from '@hungryroot/tags';

const createFilters = (init?: Partial<Filter>): Filter => {
  return Object.assign(
    {
      title: '',
      queryKey: null,
      queryValue: '1',
      requestKey: null,
      requestValue: '1',
      pillText: null,
      pillOrder: 0,
      menuOrder: 0,
      hidden: false,
      tag: null,
      type: '',
      options: [],
    },
    init
  );
};

/** Bottom filters for discover cookbooks; aligned with recipe catalog naming. */
export const cookbookFilters: FilterGroup = {
  topFilters: [],
  bottomFilters: [
    createFilters({
      title: 'Dietary Needs',
      type: 'and',
      menuOrder: 1,
      pillOrder: 1,
      pillText: 'Diet',
      options: [
        createFilters({
          title: 'Vegan',
          menuOrder: 1,
          pillOrder: 1,
          requestKey: 'is_vegan',
          queryKey: 'is_vegan',
        }),
        createFilters({
          title: 'Vegetarian',
          menuOrder: 2,
          pillOrder: 2,
          requestKey: 'is_vegetarian',
          queryKey: 'is_vegetarian',
        }),
        createFilters({
          title: 'Pescatarian',
          menuOrder: 3,
          pillOrder: 3,
          requestKey: 'is_pescatarian',
          queryKey: 'is_pescatarian',
        }),
      ],
    }),
    createFilters({
      title: 'Cook Time',
      type: 'choose_one',
      menuOrder: 3,
      pillOrder: 3,
      options: [
        // Cook-time tags (187–189) match RecipeFiltersV2; not in @hungryroot/tags.
        createFilters({
          title: '5 Minutes Or Less',
          pillText: '<5 Minutes',
          menuOrder: 1,
          pillOrder: 1,
          tag: 187,
          requestKey: 'max_cooking_time',
          requestValue: '5',
          queryKey: 'max_cooking_time',
          queryValue: '5',
        }),
        createFilters({
          title: '10 Minutes Or Less',
          pillText: '<10 Minutes',
          menuOrder: 2,
          pillOrder: 2,
          tag: 188,
          requestKey: 'max_cooking_time',
          requestValue: '10',
          queryKey: 'max_cooking_time',
          queryValue: '10',
        }),
        createFilters({
          title: '20 Minutes Or Less',
          pillText: '<20 Minutes',
          menuOrder: 3,
          pillOrder: 3,
          tag: 189,
          requestKey: 'max_cooking_time',
          requestValue: '20',
          queryKey: 'max_cooking_time',
          queryValue: '20',
        }),
      ],
    }),

    createFilters({
      title: 'Nutrition',
      type: 'and',
      menuOrder: 5,
      pillOrder: 5,
      options: [
        createFilters({
          title: 'Less Sugar (<4g)',
          menuOrder: 4,
          pillOrder: 4,
          tag: tags.LessSugar,
          requestKey: 'nutrition_tags',
          requestValue: String(tags.LessSugar),
          queryKey: 'is_less_sugar',
        }),
        createFilters({
          title: 'High Protein (≥25g)',
          menuOrder: 5,
          pillOrder: 5,
          tag: tags.HighProtein,
          requestKey: 'nutrition_tags',
          requestValue: String(tags.HighProtein),
          queryKey: 'is_high_protein',
        }),
        createFilters({
          title: 'Less Sodium (<500mg)',
          menuOrder: 6,
          pillOrder: 6,
          tag: tags.LowSodium,
          requestKey: 'nutrition_tags',
          requestValue: String(tags.LowSodium),
          queryKey: 'is_less_sodium',
        }),
        createFilters({
          title: 'Anti-inflammatory',
          menuOrder: 7,
          pillOrder: 7,
          tag: tags.AntiInflamitory,
          requestKey: 'nutrition_tags',
          requestValue: String(tags.AntiInflamitory),
          queryKey: 'is_anti_inflammatory',
        }),
        createFilters({
          title: 'High Fiber',
          menuOrder: 8,
          pillOrder: 8,
          tag: tags.HighFiber,
          requestKey: 'nutrition_tags',
          requestValue: String(tags.HighFiber),
          queryKey: 'is_high_fiber',
        }),
      ],
    }),
  ],
  query: '',
};
